var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reveal-ops-menu-bar" }, [
    _c(
      "div",
      { staticClass: "reveal-ops-menu-group" },
      [
        _c(
          "b-dropdown",
          {
            staticClass: "reveal-ops-menu",
            attrs: {
              text: "Search",
              size: "sm",
              variant: "link",
              "toggle-class": "reveal-ops-menu-toggle",
              "menu-class": "reveal-ops-menu-list",
              disabled: _vm.busy,
            },
          },
          [
            _c(
              "b-dropdown-item",
              {
                attrs: { "link-class": "reveal-ops-menu-item" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("reset-search")
                  },
                },
              },
              [_vm._v(" Reset search ")]
            ),
            _c("b-dropdown-divider"),
            _c("b-dropdown-header", { staticClass: "reveal-ops-menu-header" }, [
              _vm._v("Search mode"),
            ]),
            _c(
              "b-dropdown-item",
              {
                attrs: { "link-class": _vm.modeItemClass("strict") },
                on: {
                  click: function ($event) {
                    return _vm.$emit("set-mode", "strict")
                  },
                },
              },
              [_vm._v(" Evidence-grounded ")]
            ),
            _c(
              "b-dropdown-item",
              {
                attrs: { "link-class": _vm.modeItemClass("relaxed") },
                on: {
                  click: function ($event) {
                    return _vm.$emit("set-mode", "relaxed")
                  },
                },
              },
              [_vm._v(" Exploratory ")]
            ),
          ],
          1
        ),
        _c(
          "b-dropdown",
          {
            staticClass: "reveal-ops-menu",
            attrs: {
              text: "Import / Export",
              size: "sm",
              variant: "link",
              "toggle-class": "reveal-ops-menu-toggle",
              "menu-class": "reveal-ops-menu-list",
              disabled: _vm.busy,
            },
          },
          [
            _c(
              "b-dropdown-item",
              {
                attrs: { "link-class": "reveal-ops-menu-item" },
                on: { click: _vm.triggerImportPicker },
              },
              [_vm._v(" Import workflow ")]
            ),
            _c(
              "b-dropdown-item",
              {
                attrs: {
                  "link-class": "reveal-ops-menu-item",
                  disabled: !_vm.canExportWorkflow,
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("export-workflow")
                  },
                },
              },
              [_vm._v(" Export workflow ")]
            ),
          ],
          1
        ),
        _vm.queryBuilderVisible
          ? _c(
              "b-dropdown",
              {
                staticClass: "reveal-ops-menu",
                attrs: {
                  text: "Query builder",
                  size: "sm",
                  variant: "link",
                  "toggle-class": "reveal-ops-menu-toggle",
                  "menu-class": "reveal-ops-menu-list",
                  disabled: _vm.busy,
                },
              },
              [
                _c(
                  "b-dropdown-item",
                  {
                    attrs: { "link-class": "reveal-ops-menu-item" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("open-query-builder")
                      },
                    },
                  },
                  [_vm._v(" Guided query builder ")]
                ),
                _c(
                  "b-dropdown-item",
                  {
                    attrs: { "link-class": "reveal-ops-menu-item" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("open-query-guidelines")
                      },
                    },
                  },
                  [_vm._v(" How to build your query ")]
                ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "b-dropdown",
          {
            staticClass: "reveal-ops-menu",
            attrs: {
              text: "Help",
              size: "sm",
              variant: "link",
              right: "",
              "toggle-class": "reveal-ops-menu-toggle",
              "menu-class": "reveal-ops-menu-list",
            },
          },
          [
            _c(
              "b-dropdown-item",
              {
                attrs: { "link-class": "reveal-ops-menu-item" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("open-search-terms-extraction")
                  },
                },
              },
              [_vm._v(" How search terms are extracted ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("input", {
      ref: "workflowImportFileInput",
      staticClass: "d-none",
      attrs: { type: "file", accept: "application/json,.json" },
      on: { change: _vm.onImportFileChange },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }